import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import InputGroup from 'react-bootstrap/InputGroup';
import { Search } from 'react-bootstrap-icons';

const SearchProducts = (params) => {
  const history = useHistory(); // for routing
  const [searchString, setSearchString] = useState('');

  const handleChange = (e) => {
    setSearchString(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    history.push(`/products/search/${searchString}`);
  }

  return (
    <Form className="search-products" inline onSubmit={handleSubmit}>
      <InputGroup className="mb-3">
        <FormControl type="text" placeholder="Search" className="mr-xs-0"
          onChange={handleChange} value={searchString}/>
        <InputGroup.Append>
          <InputGroup.Text id="search" className="pointer" onClick={handleSubmit}>
            <Search />
          </InputGroup.Text>
        </InputGroup.Append>
      </InputGroup>
    </Form>
  );
}

export default SearchProducts;